import React, { Component } from 'react';
import PropTypes from 'prop-types';


export default class Services extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowing: true,
      showingServices: props.serviceIds.length < 9 ? props.serviceIds.length : 7,
    };
  }

  render() {
    const { serviceIds, servicesLiteral, baseClassName, t } = this.props;
    const { showingServices, isShowing } = this.state;

    const lengthIds = serviceIds.length;
    const serviceList = serviceIds.map((id, i) => (
      i < showingServices
        ? (
          <li key={ i } className="services__list__item">
            <div className="services__list__item__container">
              <i className={ `services__list__item__container__icon hundredicons-services-${id}` } />
              <span className="services__list__item__container__text">
                { servicesLiteral(t, id) }
              </span>
            </div>
          </li>
        ) : ''
    ));

    return (
      <div className={ `services ${baseClassName}` }>
        <h2 className="services__title">
          { t("Services") }
        </h2>
        <ul className="services__list">
          { serviceList }
          { serviceIds.length > 8 && isShowing
            && (
              <li className="services__list__last-item">
                <div
                  className="services__list__item__container"
                  onClick={ () => this.setState({ isShowing: false, showingServices: lengthIds }) }
                >
                  { t("See {num} more", { num: lengthIds - 7 }) }
                </div>
              </li>
            )
          }
        </ul>
      </div>
    );
  }
}

Services.propTypes = {
  baseClassName: PropTypes.string.isRequired,
  serviceIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  servicesLiteral: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};
